import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import { TestId } from '../../enums/test';
import { Message } from '../Message/index.types';

type Props = {
    timestamp: Message['createdAt'];
    className?: string;
};

function Timestamp({ timestamp, className }: Props) {
    const getFormattedTimestamp = () => {
        if (typeof timestamp === 'string') return format(parseISO(timestamp), 'h:mm a');
        return format(timestamp, 'h:mm a');
    };

    return (
        <Typography variant='body-2xs' className={clsx('text-charcoal-600', className)} data-testid={TestId.TIMESTAMP}>
            {getFormattedTimestamp()}
        </Typography>
    );
}

export default Timestamp;
